module.exports = __webpack_public_path__ + "img/PDM-600-Mobile-Trafo1.1eb91b5ccffdbbd1eb99fc45cbdb8120.avif";